import { ReactNode } from "react";

type Props = {
  children: ReactNode;
};

export default function ShopWrapper({ children }: Props) {
  return (
    <div className="flex flex-col justify-center items-center gap-1 h-[100vh] w-full min-h-[37.5rem] tall:gap-10">
      {children}
    </div>
  );
}
